import React, { useEffect } from 'react';
import HeaderSCI from './HeaderSCI';
import './controlinterno.css';

const documentos = [
  "Acuerdo que crea el Comité de Control Interno y Desempeño Institucional de la Secretaría de Contraloría.",
  "Lineamientos Generales para la Integración, Organización y Funcionamiento de los Comités de Ética y Prevención de Conflictos de Interés.",
  "Acuerdo que crea el Comité de Ética y Prevención de Conflictos de Interés de la Secretaría de Contraloría del Poder Ejecutivo del Estado de Hidalgo",
  "Código de Ética de la Administración Pública del Estado de Hidalgo.",
  "Disposiciones y Manual Administrativo de Aplicación Estatal en Materia de Control Interno.",
  "Modelo Estatal de Marco Integrado de Control Interno para el Sector Público del Estado de Hidalgo."
];

const AntecedentesNormativos = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <HeaderSCI title="ANTECEDENTES NORMATIVOS" />

      {/* ── DOCUMENT LIST ── */}
      <div className="container ci-nav" style={{ maxWidth: '1000px' }}>
        <div className="row justify-content-center">
          {documentos.map((doc, idx) => (
            <div key={idx} className="col-lg-6 col-md-6 col-12 mb-2">
              <a href="#" className="ci-nav__btn ci-nav__btn--doc">
                <div className="ci-nav__icon">
                  <i className="fa-regular fa-address-card"></i>
                </div>
                <span className="ci-nav__label ci-nav__label--doc">{doc}</span>
              </a>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default AntecedentesNormativos;
